import { render, staticRenderFns } from "./qualification-form-nbn.vue?vue&type=template&id=3bcf1a08&scoped=true"
import script from "./qualification-form-nbn.vue?vue&type=script&lang=js"
export * from "./qualification-form-nbn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf1a08",
  null
  
)

export default component.exports